/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Total_Budget_Max_LabelInputs */



/**
* | output |
* | --- |
* | "Max possible" |
*
* @param {Usage_Total_Budget_Max_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_total_budget_max_label = /** @type {((inputs?: Usage_Total_Budget_Max_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Total_Budget_Max_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Maximal möglich")
	return /** @type {LocalizedString} */ ("Max possible")
});